"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment/moment"));
var _reactMoment = _interopRequireDefault(require("react-moment"));
var _TimestampModule = _interopRequireDefault(require("../../styles/components/Circles/Timestamp.module.css"));
var _useGetValue = require("../../hooks/useGetValue");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Timestamp = _ref => {
  let {
    isCorrect = false,
    thingPDIDDevice,
    displayNameId,
    hover = false
  } = _ref;
  const {
    timestamp = null
  } = (0, _useGetValue.useGetDeviceValueByParams)({
    displayNameId,
    thingPDIDDevice
  });
  const [show, setShow] = (0, _react.useState)(false);
  const timeout = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (timeout.current) clearTimeout(timeout.current);
    if (hover) {
      setShow(true);
    } else {
      timeout.current = setTimeout(() => setShow(false), 500);
    }
  }, [hover]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TimestampModule.default.time_box, " time-box ").concat(show ? 'time-box-for-hover' : '')
  }, timestamp && isCorrect ? _moment.default.duration((0, _moment.default)().diff(timestamp)).asHours() < 24 ? /*#__PURE__*/_react.default.createElement(_reactMoment.default, {
    format: "LT"
  }, timestamp) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactMoment.default, {
    format: "D MMM"
  }, timestamp), /*#__PURE__*/_react.default.createElement(_reactMoment.default, {
    format: "h:mm A"
  }, timestamp)) : '- -'), [timestamp, isCorrect, show]);
};
var _default = exports.default = Timestamp;